import { useSensor, useSensors, PointerSensor, KeyboardSensor } from "@dnd-kit/core";
import { sortableKeyboardCoordinates } from "@dnd-kit/sortable";

/** Pointer + keyboard sensors tuned for corkboard-style drag (desktop + touch). */
export function useDeskDnDSensors(locked) {
  return useSensors(
    useSensor(PointerSensor, {
      activationConstraint: { distance: 6 },
    }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );
}

export const NB_PREFIX = "sort-nb-";
export const TXT_PREFIX = "sort-txt-";
export const DROP_DRAWER_PREFIX = "drop-drawer-";
export const DROP_NB_PREFIX = "drop-nb-";

export function nbSortId(id) {
  return `${NB_PREFIX}${id}`;
}
export function txtSortId(id) {
  return `${TXT_PREFIX}${id}`;
}
export function parseSortId(sortId) {
  const s = String(sortId);
  if (s.startsWith(NB_PREFIX)) return { type: "notebook", id: s.slice(NB_PREFIX.length) };
  if (s.startsWith(TXT_PREFIX)) return { type: "text", id: s.slice(TXT_PREFIX.length) };
  if (s.startsWith(DROP_DRAWER_PREFIX)) return { type: "drawer-drop", id: s.slice(DROP_DRAWER_PREFIX.length) };
  if (s.startsWith(DROP_NB_PREFIX)) return { type: "notebook-drop", id: s.slice(DROP_NB_PREFIX.length) };
  return null;
}
